import React, { useState } from "react";
import {
    Navigate,
    Route,
    BrowserRouter as Router,
    Routes,
} from "react-router-dom";
import {
    Alarms,
    Analytics,
    BusinessAnalytics,
    CallLog,
    CallResponseTime,
    CallTimingsCard,
    Category,
    ChangePassword,
    CommonLayout,
    Contacts,
    DailyCoTable,
    TransactionsDetails,
    DemoGraphic,
    Details,
    Expenditure,
    ForgotPassword,
    GitDashboardChart,
    GitDashboardTable,
    Home,
    HotelDashboard,
    HotelDashboardTickets,
    HotelStaffResponseTime,
    HotelWidgets,
    HubSpotTable,
    JiraDashboard,
    JiraTicketsTable,
    KioskPropertiesTable,
    LikeDislikeTable,
    LinkExpired,
    LogIn,
    NewCallDetailsTable,
    NotFound,
    OperationDetails,
    QueueInstances,
    ReportsTable,
    RestartHistoryTable,
    Reviews,
    ReviewsTable,
    RoomsAvailable,
    ScanDetailsTable,
    ServerInstances,
    SprintAnalytics,
    SupportDetailsTable,
    TeamManagement,
    TicketForm,
    TicketsByComponents,
    TicketsByPriorityTable,
    TotalTimeDuration,
    TransactionDuration,
    TransactionDurationTable,
    UserList,
    VendorList,
    VerifyOTP as VerifyLogInOTP,
    ConfirmPassword as VerifyPassword,
    WalkInLog,
    CallsAnswered,
    CallsAnsweredDetails,
    MissedCalls,
    MissedCallDetails,
    FrontDeskConnection,
    IdScannedAudit,
    VideoRecordings,
    PerformanceInsights,
    KeyInsights,
} from "./components";
import BuildUploader from "./components/BuildUploader/BuildUploader";
import MapContainer from "./components/Map/MapContainer";
import SupportAnalytics from "./components/SupportAnalytics/SupportAnalytics";
import Nexus from "./components/Nexus/Index";
import NexusHotel from "./components/Nexus/NexusHotel";
import NexusAgentStatus from "./components/Nexus/NexusAgentStatus";
import ShiftNotes from "./components/ShiftNotes/ShiftNotes";
import HotelShiftNotes from "./components/ShiftNotes/HotelShiftNotes";
import Receipt from "./components/ReceiptAnalytics/Receipt";
import HotelReceipts from "./components/ReceiptAnalytics/HotelReceipts";
import ReceiptDetails from "./components/ReceiptAnalytics/ReceiptDetails";
import { getUserRole, initialDateRange } from "./services/util";
import { QualityMatricsDetails } from "./components/Details/QualityMatricsDetails";
import CallWaitingDetails from "./components/Nexus/CallWaiting/CallWaitingDetails";
import MissedCallRate from "./components/MissedCallRate/MissedCallRate";
import CallLogDetails from "./components/CallLog/CallLogDetails";
import { useAuth0 } from "@auth0/auth0-react";

const SettingContext = React.createContext();

export function CustomRoutes() {
    const userRole = getUserRole();
    const hideDashboard =
        userRole === "Customer" || userRole === "External Vendor";
    const [selectedDates, setSelectedDates] = useState(initialDateRange);
    const [selectedHotelType, setSelectedHotelType] = useState("all");
    const [selectedHotelActiveType, setSelectedHotelActiveType] =
        useState("all");
    const [selectedHotelGroup, setSelectedHotelGroup] = useState(["all"]);
    const [selectedServiceModel, setSelectedServiceModel] = useState(["all"]);
    const [selectedCallCenters, setSelectedCallCenters] = useState("all");
    const [selectedShifts, setSelectedShifts] = useState([]);
    const [selectedHotels, setSelectedHotels] = useState([]);
    const [singleSelectedHotels, setSingleSelectedHotels] = useState("");
    const [kioskSelection, setKioskSelection] = useState("1");
    const [loggedIn, setLoggedIn] = useState(
        Boolean(localStorage.getItem(`loggedIn`)),
    );
    const [rabbitClient, setRabbitClient] = useState(null);
    const [rabbitQueue, setRabbitQueue] = useState(null);
    const [selectedCheckinType, setSelectedCheckinType] = useState(0);
    const [selectedReceiptTab, setSelectedRecipetTab] = useState("mail");
    const [selectedNexusHotelId, setSelectedNexusHotelId] = useState([]);
    const [selectedNexusDates, setSelectedNexusDates] =
        useState(initialDateRange);
    const [callWaitingTab, setCallWaitingTab] = useState("call_waiting");

    const [homeActiveTab, updateHomeActiveTab] = useState("1");
    const context = {
        selectedDates,
        setSelectedDates,
        selectedHotels,
        setSelectedHotels,
        loggedIn,
        setLoggedIn,
        singleSelectedHotels,
        setSingleSelectedHotels,
        selectedHotelType,
        setSelectedHotelType,
        selectedHotelActiveType,
        setSelectedHotelActiveType,
        selectedHotelGroup,
        setSelectedHotelGroup,
        selectedServiceModel,
        setSelectedServiceModel,
        selectedCallCenters,
        setSelectedCallCenters,
        selectedShifts,
        setSelectedShifts,
        kioskSelection,
        setKioskSelection,
        rabbitClient,
        setRabbitClient,
        rabbitQueue,
        setRabbitQueue,
        selectedCheckinType,
        setSelectedCheckinType,
        selectedReceiptTab,
        setSelectedRecipetTab,
        selectedNexusHotelId,
        setSelectedNexusHotelId,
        selectedNexusDates,
        setSelectedNexusDates,
        homeActiveTab,
        updateHomeActiveTab,
        callWaitingTab,
        setCallWaitingTab,
    };

    return (
        <SettingContext.Provider value={context}>
            <Router>
                <Routes>
                    <Route
                        path="/"
                        element={
                            loggedIn && hideDashboard ? (
                                <Navigate to="/performance-insights" replace />
                            ) : (
                                <CommonLayout>
                                    <Home />
                                </CommonLayout>
                            )
                        }
                    />
                    <Route
                        path="/video-recordings"
                        element={
                            <CommonLayout>
                                <VideoRecordings />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/performance-insights"
                        element={
                            <CommonLayout>
                                <PerformanceInsights />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/key-insights"
                        element={
                            <CommonLayout>
                                <KeyInsights />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/nexus-dashboard"
                        element={
                            <CommonLayout>
                                <Nexus />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/details/:type"
                        element={
                            <CommonLayout>
                                <Details />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/quality-metrics-details/:component"
                        element={
                            <CommonLayout>
                                <QualityMatricsDetails />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/total-time-duration"
                        element={
                            <CommonLayout>
                                <TotalTimeDuration />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/calls/:hotel_id"
                        element={
                            <CommonLayout>
                                <DailyCoTable />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/transactions/:hotel_id"
                        element={
                            <CommonLayout>
                                <TransactionsDetails />
                            </CommonLayout>
                        }
                    />

                    <Route
                        path="/analytics"
                        element={
                            <CommonLayout>
                                <Analytics />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/sprint-analytics"
                        element={
                            <CommonLayout>
                                <SprintAnalytics />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/support-analytics"
                        element={
                            <CommonLayout>
                                <SupportAnalytics />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/team-manangement"
                        element={
                            <CommonLayout>
                                <TeamManagement />
                            </CommonLayout>
                        }
                    />
                    <Route path="/verify-otp" element={<VerifyLogInOTP />} />
                    <Route
                        path="/change-password"
                        element={<ChangePassword />}
                    />
                    <Route
                        path="/forgot-password"
                        element={<ForgotPassword />}
                    />
                    <Route
                        path="/verify-password"
                        element={<VerifyPassword />}
                    />
                    <Route path="/link-expired" element={<LinkExpired />} />
                    <Route path="/map" element={<MapContainer />} />
                    <Route path="/category" element={<Category />} />
                    <Route
                        path="/demographic-analytics"
                        element={
                            <CommonLayout>
                                <DemoGraphic />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/kiosk-properties"
                        element={
                            <CommonLayout>
                                <KioskPropertiesTable />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/vendors"
                        element={
                            <CommonLayout>
                                <VendorList />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/ticket-form"
                        element={
                            <CommonLayout>
                                <TicketForm />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/reviews-table"
                        element={
                            <CommonLayout>
                                <ReviewsTable />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/new-call-details"
                        element={
                            <CommonLayout>
                                <NewCallDetailsTable />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/call-log"
                        element={
                            <CommonLayout>
                                <CallLog />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/call-log/:hotel_id"
                        element={
                            <CommonLayout>
                                <CallLogDetails />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/walkIn-log"
                        element={
                            <CommonLayout>
                                <WalkInLog />
                            </CommonLayout>
                        }
                    />
                    <Route path="/call-time" element={<CallTimingsCard />} />
                    <Route path="/reviews-graph" element={<Reviews />} />
                    <Route
                        path="/transaction-duration-table"
                        element={
                            <CommonLayout>
                                <TransactionDurationTable />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/call-answered"
                        element={
                            <CommonLayout>
                                <CallsAnswered />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/call-missed"
                        element={
                            <CommonLayout>
                                <MissedCalls />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/call-answered-details/:id"
                        element={
                            <CommonLayout>
                                <CallsAnsweredDetails />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/call-missed-details/:id"
                        element={
                            <CommonLayout>
                                <MissedCallDetails />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/operation-details"
                        element={<OperationDetails />}
                    />
                    <Route
                        path="/hotel-dashboard"
                        element={<HotelDashboard />}
                    />
                    <Route
                        path="/hotel-dashboard/tickets/:type"
                        element={<HotelDashboardTickets />}
                    />
                    <Route
                        path="/scan-details-table"
                        element={
                            <CommonLayout>
                                <ScanDetailsTable />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/support-details-table"
                        element={
                            <CommonLayout>
                                <SupportDetailsTable />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/hubSpot-details-table"
                        element={<HubSpotTable />}
                    />
                    <Route
                        path="/like-dislike-details"
                        element={
                            <CommonLayout>
                                <LikeDislikeTable />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/transaction-duration-graph/:hotel_id"
                        element={<TransactionDuration />}
                    />
                    <Route
                        path="/shift_notes"
                        element={
                            <CommonLayout>
                                <ShiftNotes />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/shift_notes/:hotel_id"
                        element={
                            <CommonLayout>
                                <HotelShiftNotes />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/sent_receipt"
                        element={
                            <CommonLayout>
                                <Receipt />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/sent_receipt/:hotel_id"
                        element={
                            <CommonLayout>
                                <HotelReceipts />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/sent_receipt/:hotel_id/:receipt_is_for"
                        element={
                            <CommonLayout>
                                <ReceiptDetails />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/jira-dashboard"
                        element={
                            <CommonLayout>
                                <JiraDashboard />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/jira-dashboard/tickets/:range"
                        element={<JiraTicketsTable />}
                    />
                    <Route
                        path="/jira-dashboard/priority-tickets/:priority"
                        element={<TicketsByPriorityTable />}
                    />
                    <Route
                        path="/tickets-chart"
                        element={
                            <CommonLayout>
                                <TicketsByComponents />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/git-dashboard"
                        element={
                            <CommonLayout>
                                <GitDashboardChart />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/git-dashboard/table"
                        element={<GitDashboardTable />}
                    />
                    <Route
                        path="/hotels"
                        element={
                            <CommonLayout>
                                <HotelWidgets />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/users"
                        element={
                            <CommonLayout>
                                <UserList />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/alarms"
                        element={
                            <CommonLayout>
                                <Alarms />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/rooms"
                        element={
                            <CommonLayout>
                                <RoomsAvailable />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/report-settings"
                        element={
                            <CommonLayout>
                                <ReportsTable />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/business-analytics"
                        element={
                            <CommonLayout>
                                <BusinessAnalytics />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/restart-history"
                        element={<RestartHistoryTable />}
                    />
                    <Route
                        path="/build-upload"
                        element={
                            <CommonLayout>
                                <BuildUploader />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/queue-instances"
                        element={
                            <CommonLayout>
                                <QueueInstances />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/server-instances"
                        element={
                            <CommonLayout>
                                <ServerInstances />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/Expenditure"
                        element={
                            <CommonLayout>
                                <Expenditure />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/contacts"
                        element={
                            <CommonLayout>
                                <Contacts />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/nexus-hotels"
                        element={
                            <CommonLayout>
                                <NexusHotel />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/nexus-agents-status"
                        element={
                            <CommonLayout>
                                <NexusAgentStatus />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/nexus-agents-status/call-wating-detail"
                        element={
                            <CommonLayout>
                                <CallWaitingDetails />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/average_reponse_time"
                        element={
                            <CommonLayout>
                                <CallResponseTime />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/average_staff_reponse_time"
                        element={<HotelStaffResponseTime />}
                    />
                    <Route
                        path="/missed-call-rate"
                        element={
                            <CommonLayout>
                                <MissedCallRate />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/frontdesk-connection-details"
                        element={
                            <CommonLayout>
                                <FrontDeskConnection />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/id-scanned-audit"
                        element={<IdScannedAudit />}
                    />
                    <Route path="/404" element={<NotFound />} />
                    <Route path="*" element={<NotFound />} />
                    <Route path="/login" element={<LogIn />} />
                </Routes>
            </Router>
        </SettingContext.Provider>
    );
}

export { SettingContext };
